<header class="header" id="header">
  <nav aria-labelledby="header">
    <h2>Simulador de formalización</h2>
    <img src="/assets/images/logoDian-ligth.png" alt="icon">
</nav>
</header>
